import { createContext } from "react";

const DF_LO0024Context = createContext();

export { DF_LO0024Context };